import moment from 'moment';
import HelperMixin from '../../../Shared/HelperMixin.vue';
import PaginationHelper from '../../../Shared/PaginationHelper.vue';

export default {
    name: 'CardsList',
    mixins: [HelperMixin],
    components: {
        PaginationHelper
    },

    async created() {
        this.loginDetails = await this.CheckLoginStatus();

        if (!this.requireUserType([1])) return;

        this.GetInfo();
    },

    computed: {
        totalPages() {
            return Math.ceil(this.pages / this.pageSize);
        }
    },

    filters: {
        moment: function (date) {
            if (!date) {
                return "—";
            }
            return moment(date).format('DD/MM/YYYY');
        }
    },

    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            Search: '',

            ScreenTitle: 'قائمة الكروت',
            ScreenTitleSingle: 'كرت',

            Info: [],
            Statistics: 0,

            // level -> الحالة / المستوى
            LevelMap: {
                1: 'تم الإنشاء',
                2: 'تم البيع',
                22: 'مفتوح',
                3: 'تم الشحن',
                4: 'مجمّد',
                5: 'منتهي'
            }
        };
    },

    methods: {

        LevelText(level) {
            return this.LevelMap[level] || '—';
        },

        LevelPill(level) {
            switch (Number(level)) {
                case 1: return 'pill-gray';      // تم الإنشاء
                case 2: return 'pill-dark';      // تم البيع
                case 22: return 'pill-warning';  // مفتوح
                case 3: return 'pill-success';   // تم الشحن
                case 4: return 'pill-danger';    // مجمّد
                case 5: return 'pill-danger';    // منتهي
                default: return 'pill-gray';
            }
        },

        GetInfo(pageNo) {
            this.pageNo = pageNo;
            if (this.pageNo === undefined) {
                this.pageNo = 1;
            }

            if (!this.Search)
                this.$blockUI.Start();

            this.$http.GetCardsList(this.pageNo, this.pageSize, this.Search)
                .then(response => {
                    if (!this.Search)
                        this.$blockUI.Stop();

                    const data = response.data || {};
                    this.Info = data.info || [];
                    this.pages = data.count || 0;

                    const s = data.statistics || {};
                    this.Statistics = {
                        count: s.count ?? s.Count ?? 0,
                        totalValue: s.totalValue ?? s.TotalValue ?? 0
                    };
                })
                .catch(() => {
                    if (!this.Search)
                        this.$blockUI.Stop();
                    this.Info = [];
                    this.pages = 0;
                    this.Statistics = 0;
                });
        },

        Refresh() {
            this.Search = '';
            this.GetInfo(1);
        }
    }
}
